import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { storeToRefs } from 'pinia';
import type { CreateElement } from 'vue';

import { computed } from 'vue';

export default {
	setup() {
		const { urlMetadata } = storeToRefs(useRoutingStore());

		const styles = computed(() => urlMetadata.value?.htmlContentJson?.styles ?? null);

		return (h: CreateElement) => h('style', { domProps: { innerHTML: styles.value } });
	},
};
